import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheckCircle} from "@fortawesome/free-solid-svg-icons";
import "./promolist.scss";

const footerup = () => {
  const handleConsultationClick = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6281188083575&text=Halo%20Thobie,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20Summarecon%20Serpong%20(Promo%20Anniversary)%20https://marketing-gadingserpong.com//&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };
  return (
    <div className="footerup">
      <div className="containerfooter">
        <div className="desk1">
          <h1>Diskon Up To 20% Selected Units</h1>
          <div className="promolist1">
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckCircle} />
              <span style={{color: "black"}}>&nbsp;&nbsp;Siap Huni</span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckCircle} />
              <span style={{color: "black"}}>&nbsp;&nbsp;Free PPN 100%</span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckCircle} />
              <span style={{color: "black"}}>&nbsp;&nbsp;Free Biaya KPR</span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckCircle} />
              <span style={{color: "black"}}>&nbsp;&nbsp;Free Biaya BPHTB</span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckCircle} />
              <span style={{color: "black"}}>
                &nbsp;&nbsp;Free Biaya KPR Balik Nama
              </span>
            </div>
          </div>
        </div>
        <hr />
        <div className="desk2">
          <h1>Hadiah Langsung</h1>
          <div className="promolist2">
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckCircle} />
              <span style={{color: "black"}}>&nbsp;&nbsp;Free AC Daikin</span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckCircle} />
              <span style={{color: "black"}}>
                &nbsp;&nbsp;Free Kulkas Sharp
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckCircle} />
              <span style={{color: "black"}}>
                &nbsp;&nbsp;Free Sepeda Polygon
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckCircle} />
              <span style={{color: "black"}}>
                &nbsp;&nbsp;Free Logam Mulia 10 Gram
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckCircle} />
              <span style={{color: "black"}}>
                &nbsp;&nbsp;Italy Cutlery (Spoon, Fork, Plate)
              </span>
            </div>
          </div>
        </div>
        <hr />
        <div className="desk3">
          <h1>Hadiah Grand Prize</h1>
          <div className="promolist3">
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckCircle} />
              <span style={{color: "black"}}>&nbsp;&nbsp;Free Iphone 16</span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckCircle} />
              <span style={{color: "black"}}>&nbsp;&nbsp;Free Motor Nmax</span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckCircle} />
              <span style={{color: "black"}}>
                &nbsp;&nbsp;Free Logam Mulia 50gr
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckCircle} />
              <span style={{color: "black"}}>
                &nbsp;&nbsp;Free Mobil BYD M6
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckCircle} />
              <span style={{color: "black"}}>
                &nbsp;&nbsp;Free Mobil BYD Seal
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="button">
        <div className="container-wa">
          <button className="buttonpenawaran" onClick={handleConsultationClick}>
            More Info
          </button>
        </div>
      </div>
    </div>
  );
};

export default footerup;
